var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 61,
    viewBox: "0 0 107 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.327648,
    y: 0.327648,
    width: 105.503,
    height: 59.632,
    rx: 3.60413,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.655296
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 35H59.6667V38.3333H63M63 28.3333H59.6667V31.6667H63M66.3334 41.6667H53V38.3333H56.3334V35H53V31.6667H56.3334V28.3333H53V25H66.3334M49.6667 21.6667H46.3334V18.3333H49.6667M49.6667 28.3333H46.3334V25H49.6667M49.6667 35H46.3334V31.6667H49.6667M49.6667 41.6667H46.3334V38.3333H49.6667M43 21.6667H39.6667V18.3333H43M43 28.3333H39.6667V25H43M43 35H39.6667V31.6667H43M43 41.6667H39.6667V38.3333H43M53 21.6667V15H36.3334V45H69.6667V21.6667H53Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.b65d65d5d7acf2ad994b1f02a723538f.svg";
export { ForwardRef as ReactComponent };